<template><div><h1>VUX V2.8.1 发布日志</h1>
<h2><a href="/zh-CN/components/cell.html">Cell</a></h2>
<ul><li>[fix] 修复 justify 类名 #2545</li>
</ul>
<h2><a href="/zh-CN/components/grid.html">Grid</a></h2>
<ul><li>[feature] 支持 prop:show-lr-borders、prop:show-vertical-dividers 用以隐藏左右边线及垂直分割线 #2488</li>
</ul>
<h2><a href="/zh-CN/components/previewer.html">Previewer</a></h2>
<ul><li>[feature] 支持事件 on-index-change #2505</li>
</ul>
<h2><a href="/zh-CN/components/tab.html">Tab</a></h2>
<ul><li>[feature] 支持滚动</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[feature] 添加 slot:right-full-height 用于方便显示验证码图片 #2475</li>
</ul>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] 修复单独插件引用时无样式 #2375</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.8.1 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.8.1-272.vue?a18e5a16